import { DatePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef,
  MatRow, MatRowDef,
  MatTable
} from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { AdminService } from '../../../../admin/admin.service';
import { ReportFieldOptionsService } from '../../../../datatools-settings/report-field-options/report-field-options/report-field-options.service';
import { DatatoolsLiteService } from '../../../../shared/services/datatools-lite.service';
import { DuplikitMergeService } from '../../../../shared/services/duplikit-merge.service';
import { UserInterfaceService } from '../../../../shared/services/user-interface.service';
import { MessageNotificationService } from '../../../../shared/services/message-notification.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { DuplicateService } from '../../../duplicate.service';
import { DuplikitReportField } from '../../duplikit-report-field';
import { GenericDuplicateDetailsComponent } from '../generic-duplicate-details.component';

@Component({
  selector: 'app-candidate-duplicate-details',
  templateUrl: '../duplicate-details.component.html',
  imports: [
    NgIf,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatButton,
    NgClass,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatHeaderCellDef,
    MatCell,
    MatCellDef,
    MatTooltip,
    DatePipe,
    MatPaginator,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef,
    NgForOf
  ],
  styleUrls: ['../duplicate-details.component.scss']
})
export class CandidateDuplicateDetailsComponent extends GenericDuplicateDetailsComponent {
  defaultFieldList: DuplikitReportField[] = [
    { label: 'Date Added', field: 'dateAdded', dataType: 'date' },
    { label: 'SSN', field: 'ssn' },
    { label: 'Email', field: 'email' },
    { label: 'Email 2', field: 'email2' },
    { label: 'Email 3', field: 'email3' },
    { label: 'Phone', field: 'phone' },
    { label: 'Phone 2', field: 'phone2' },
    { label: 'Phone 3', field: 'phone3' },
    { label: 'Work Phone', field: 'workPhone' },
    { label: 'Mobile', field: 'mobile' },
    { label: 'Owner', field: 'owner', dataType: 'ID', complex: ['ownerName', 'ownerId']},
    { label: 'Date Last Modified', field: 'dateLastModified', dataType: 'date' },
    { label: 'Placement Date Added', field: 'dateLastPlaced', dataType: 'date' },
    { label: 'Date Last Note', field: 'dateLastComment', dataType: 'date' },
    { label: 'Date of Birth', field: 'dateOfBirth', dataType: 'date' },
    { label: 'Address 1', field: 'address1' },
    { label: 'City', field: 'city' },
    { label: 'State', field: 'state' },
    { label: 'Zip Code', field: 'zip' },
    { label: 'Status', field: 'status' },
    { label: 'Company', field: 'companyName' },
  ];

  constructor(
  messageNotificationService: MessageNotificationService,
  duplicateService: DuplicateService,
  adminService: AdminService,
  dataToolsLiteService: DatatoolsLiteService,
  reportFieldOptionsService: ReportFieldOptionsService,
  utilsService: UtilsService,
  duplikitMergeService: DuplikitMergeService,
  userInterfaceService: UserInterfaceService,
  ) {
    super(
        messageNotificationService,
        duplicateService,
        adminService,
        dataToolsLiteService,
        reportFieldOptionsService,
        utilsService,
        duplikitMergeService,
        userInterfaceService
    );
  }
}
